import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

export class UpdateAnioAcademico extends Component {
  static displayName = UpdateAnioAcademico.name;

  constructor(props) {
    super(props);
    this.state = {
      loadingInitial: true,
      loading: false,
      loadError: '',
      descripcion: '',
      errorMessage: '',
      redirect: false,
      id: this.props.match.params.id,
      details: this.props.match.params.details,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  get isReadOnly() {
    return this.state.details === '1';
  }

  componentDidMount() {
    const canAccess = constantClass.canAccess('WWAnioAcademico');
    if (canAccess) {
      this.populateData();
    } else {
      this.setState({ loadingInitial: false });
    }
  }

  clearFeedback() {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: '' });
    }
  }

  async populateData() {
    this.setState({ loadingInitial: true, loadError: '' });

    const { data } = await constantClass.apiFetch('api/anioAcademico/' + this.state.id, {
      method: 'GET',
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data) || !data.returnModel) {
      this.setState({
        loadingInitial: false,
        loadError: constantClass.getApiErrorMessage(
          data,
          'No se pudieron cargar los datos del año académico.'
        ),
      });
      return;
    }

    this.setState({
      loadingInitial: false,
      descripcion: data.returnModel.anioAcademicoDescripcion,
    });
  }

  handleDescripcionChangeInput = (e) => {
    this.clearFeedback();
    this.setState({ descripcion: e.target.value });
  };

  isOkToSave() {
    return this.state.descripcion.trim().length > 0;
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.isReadOnly) {
      return;
    }
    if (isSubmitInProgress(this.state.loading)) return;
    if (!this.isOkToSave()) {
      this.setState({ errorMessage: 'El campo Descripción es obligatorio' });
      return;
    }
    this.saveStudent();
  }

  async saveStudent() {
    if (isSubmitInProgress(this.state.loading)) return;

    this.setState({ loading: true, errorMessage: '' });

    const { data } = await constantClass.apiFetch('api/anioAcademico/', {
      method: 'POST',
      body: JSON.stringify({
        AnioAcademicoDescripcion: this.state.descripcion.trim(),
        AnioAcademicoCod: parseInt(this.state.id, 10),
      }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data)) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudo actualizar el año académico. Verifique los datos e intente nuevamente.'
        ),
      });
      return;
    }

    this.setState({ loading: false, redirect: true });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/md-anios" />;
    }

    const {
      loadingInitial,
      loading,
      loadError,
      errorMessage,
      descripcion,
    } = this.state;

    const isBusy = loading;
    const title = this.isReadOnly
      ? 'Ver datos de Año Académico'
      : 'Modificar Año Académico';

    if (loadingInitial) {
      return (
        <div className="md-page md-form-page">
          <Link className="md-form-page__back" to="/md-anios">
            <BackIcon />
            Volver al listado
          </Link>
          <h1 className="md-form-page__title">{title}</h1>
          <p className="md-form-page__skeleton"><em>Cargando datos...</em></p>
        </div>
      );
    }

    if (loadError) {
      return (
        <div className="md-page md-form-page">
          <Link className="md-form-page__back" to="/md-anios">
            <BackIcon />
            Volver al listado
          </Link>
          <h1 className="md-form-page__title">{title}</h1>
          <div className="md-form-page__error" role="alert">{loadError}</div>
        </div>
      );
    }

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-anios">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">{title}</h1>
        <p className="md-form-page__subtitle">
          {this.isReadOnly
            ? 'Consulta los datos registrados del año académico.'
            : 'Actualice la descripción del año académico y guarde los cambios.'}
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <span className="md-form-page__error">{errorMessage}</span> : null}
              {loading ? (
                <span className="md-form-page__loading">Actualizando año académico, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="anio-upd-descripcion">
                Año Académico
              </label>
              <input
                id="anio-upd-descripcion"
                className="md-form-page__input"
                type="text"
                value={descripcion}
                placeholder="Ingrese año"
                onChange={this.handleDescripcionChangeInput}
                disabled={isBusy || this.isReadOnly}
                readOnly={this.isReadOnly}
                required
              />
            </div>

            {!this.isReadOnly ? (
              <div className="md-form-page__actions">
                <button type="submit" className="md-form-page__btn md-form-page__btn--primary" disabled={isBusy}>
                  Confirmar
                </button>
              </div>
            ) : null}
          </form>
        </div>
      </div>
    );
  }
}
